import axios from "axios";
const api = axios.create({
  baseURL: "https://api-ft-production.devfinite.solutions/v1",
  headers: {
    "Content-Type": "application/json",
  },
  transformRequest: [
    (data) => {
      return JSON.stringify(data);
    },
  ],
  transformResponse: [
    (data) => {
      return JSON.parse(data);
    },
  ],
});

export default api;
